// extracted by mini-css-extract-plugin
export default {"w-full":"Panel_w-full__ugF+y","panel":"Panel_panel__iE9B2","info":"Panel_info__7NGzd","btns":"Panel_btns__os35L","button":"Panel_button__S3g3D"};